import { z } from 'zod';
/**
 * Claims present in the shared `credify_token` JWT issued by login.credifyfast.com
 * (ADR-0001 D2). Deliberately minimal — NO role, org, or name. ehr verifies this
 * locally with CREDIFY_LOGIN_JWT_SECRET and maps `email` → local user.
 */
export const ssoClaimsSchema = z.object({
    userId: z.string().min(1),
    email: z.string().email(),
    exp: z.number().optional(),
});
/** The authenticated principal after SSO verification + local user mapping. */
export const authUserSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    orgId: z.string(),
    role: z.enum(['admin', 'manager', 'clinician', 'supervisor', 'front_desk']),
    supervisorId: z.string().nullable(),
});
/** Name of the shared SSO cookie. Same across every credifyfast app. */
export const SSO_COOKIE = 'credify_token';
//# sourceMappingURL=sso.js.map